module.exports = __webpack_public_path__ + "static/media/ConferenceYear2018.92bfd4fc.png";